import { useState, useEffect } from 'react';

// import datosProyectos from '../utils/data';

const Proyectos =
({
    checking,
    setChecking,
    codigos,
    codigosProyectos,
    setCodigosProyectos,
    checkboxesProyectos,
    setCheckboxesProyectos,
    proyectos,
    sorting,
    loading,
    setPagination,
    status422
}) =>
{
    const [count, setCount] = useState(0);

    const appDebug = process.env.REACT_APP_DEBUG;

    const handleCheckbox = (e) =>
    {
        console.log(new Error('This handle is deprecated.'));

        // const checked = e.target.checked;

        // if (e.target.checked === true)
        // {
        //     const codes = [];

        //     for (let i = 0; i < codigosProyectos.length; i++)
        //     {
        //         codes.push(codigosProyectos[i]);
        //     }

        //     datosProyectos['data'].map(data =>
        //     {
        //         if (e.target.value === data.nombre)
        //         {
        //             data.codigosProyectos.map(codigo =>
        //             (
        //                 codes.push(codigo.codigo)
        //             ));
        //         }
        //     });

        //     setCodigosProyectos(codes);
        // }
        // else
        // {
        //     let array = [];

        //     datosProyectos['data'].map(data =>
        //     {
        //         if (e.target.value === data.nombre)
        //         {
        //             data.codigosProyectos.map(codigo =>
        //             (
        //                 array.push(codigo.codigo)
        //             ));
        //         }
        //     });

        //     const codigos = codigosProyectos.filter(codigo => !array.includes(codigo));

        //     setCodigosProyectos(codigos);
        // }

        // let object = {};

        // datosProyectos['data'].map(data =>
        // {
        //     if (e.target.value === data.nombre)
        //     {
        //         data.codigosProyectos.map(codigo =>
        //         (
        //             object[codigo.codigo] = checked
        //         ));
        //     }
        // });

        // setCheckboxesProyectos({ ...checkboxesProyectos, ...object });

        // setPagination(1);
    }

    const handleChildCheckbox = (e) =>
    {
        setChecking(true);

        const checked = e.target.checked;
        const codigo = e.target.value;

        if (checked === true)
        {
            const proyectos = [];

            for (let i = 0; i < codigosProyectos.length; i++)
            {
                proyectos.push(codigosProyectos[i]);
            }

            proyectos.push(codigo);

            setCodigosProyectos(proyectos);
        }
        else
        {
            const proyectos = codigosProyectos.filter(proyecto => proyecto !== codigo);

            setCodigosProyectos(proyectos);
        }

        // 1. Tu lógica para actualizar el estado en React
        setCheckboxesProyectos(
        {
            ...checkboxesProyectos,
            [codigo]: checked
        });

        // 2. Enviar la acción a Google Tag Manager
        if (window.dataLayer)
        {
            window.dataLayer.push(
            {
                event: 'buscador_experto_pesqueria_checkbox_tipo_informacion',
                checkbox_tipo_informacion: document.querySelector(`label[for="${e.target.id}"]`).textContent,
                checkbox_accion: checked ? 'marcado' : 'desmarcado',
            });
        }

        setPagination(1);
    }

    useEffect(() =>
    {
        let contador = 0;

        codigos.map((codigo) => (contador += codigo.REGISTROS));

        setCount(contador);
    }, [codigos]);

    return (
        codigos.length > 0 && count > 0 ?
        (
            <div className="card border-0 mb-1">
                <h5>Filtrar por: </h5>
                <div className="accordion" id="accordionPanelProyecto">
                    <div className="accordion-item">
                        <h5 className="accordion-header"><button className="accordion-button p-2 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelProyecto" aria-expanded="true" aria-controls="panelProyecto">Proyectos / tipos:</button></h5>
                        <div id="panelProyecto" className="accordion-collapse collapse">
                            <div className="accordion" id="accordionProyectos">

                                {
                                    proyectos.map((proyecto, index) =>
                                    (
                                        <div className="accordion-item" key={index}>
                                            <h2 className="accordion-header" id={`headingProyecto-${index}`}>
                                                <button className="accordion-button ps-4 p-2 collapsed rounded-0" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseProyecto-${index}`} aria-expanded="false" aria-controls={`collapseProyecto-${index}`}>
                                                    {proyecto.TIPO_INFORMACION}
                                                </button>
                                            </h2>
                                            <div id={`collapseProyecto-${index}`} className="accordion-collapse collapse" aria-labelledby={`headingProyecto-${index}`}>
                                                <div className="accordion-body">

                                                    {
                                                        codigos.map((codigo, subIndex) =>
                                                        (
                                                            proyecto.COD_PROYECTO === codigo.COD_PROYECTO &&
                                                            (
                                                                <div key={subIndex} className="offset-1">
                                                                    <div className="form-check">
                                                                        <div className="row">
                                                                            <div className="col-9">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    className="form-check-input border-dark-subtle"
                                                                                    id={`tipo-${subIndex}`}
                                                                                    name="codigo_busqueda"
                                                                                    value={codigo.VISTA}
                                                                                    onChange={handleChildCheckbox}
                                                                                    checked={Object.hasOwn(checkboxesProyectos, `${codigo.VISTA}`) ? checkboxesProyectos[`${codigo.VISTA}`] : false}
                                                                                    disabled={!status422 && (!loading || checking || sorting)}
                                                                                />
                                                                                <label className="form-check-label" htmlFor={`tipo-${subIndex}`}>{codigo.TIPO_INFORMACION}</label>
                                                                            </div>

                                                                            {
                                                                                appDebug === 'true' &&
                                                                                (
                                                                                    <div className="col-3 no-wrap text-end">
                                                                                        {codigo.REGISTROS.toLocaleString('es-CL')}
                                                                                    </div>
                                                                                )
                                                                            }

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        ))
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }

                            </div>
                        </div>

                        {
                            appDebug === 'true' &&
                            (
                                <div className="text-end p-2">Elementos totales: {count.toLocaleString('es-CL')}</div>
                            )
                        }

                    </div>

                </div>
                
            </div>
        ) :
        (
            <div className="card border-0 mb-1">
                <h5>Filtrar por: </h5>
                <div className="accordion" id="accordionPanelProyecto">
                    <div className="accordion-item">
                        <h5 className="accordion-header"><button className="accordion-button p-2 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelProyecto" aria-expanded="true" aria-controls="panelProyecto">Proyectos / tipos:</button></h5>
                        <div id="panelProyecto" className="accordion-collapse collapse">
                            <div className="accordion" id="accordionProyectos" />
                        </div>
                    </div>
                </div>
            </div>    
        )
    );
}

export default Proyectos;
